import { render, staticRenderFns } from "./ServiciosView.vue?vue&type=template&id=4c984b5e&"
import script from "./ServiciosView.vue?vue&type=script&lang=ts&"
export * from "./ServiciosView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports